import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const MakerStrip = () => (
  <div className="flex items-center gap-5 border hairline bg-ink p-6 text-cream" data-testid="maker-strip">
    <img src="/assets/img-b3.jpeg" alt="Dr. Shibina Shemim" className="h-14 w-14 rounded-full object-cover" />
    <div className="flex-1">
      <p className="font-serif italic text-lg">Made by Dr. Shibina Shemim</p>
      <p className="mt-1 text-[12px] leading-relaxed text-cream/60">
        BAMS, PGDAC. Formulated, checked and labelled by the person whose name is on the jar.
      </p>
    </div>
    <Link to="/our-story" data-testid="maker-strip-link" aria-label="Read our story" className="hidden h-10 w-10 shrink-0 items-center justify-center rounded-full border border-cream/25 transition-colors hover:border-cream sm:flex">
      <ArrowUpRight className="h-4 w-4" />
    </Link>
  </div>
);

export default MakerStrip;
